import VueRouter from 'vue-router';
import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    console.log(to)
    if (to.meta.requiresAuth) {
      var usertoken = JSON.stringify(window.localStorage.getItem('token'))
      const authUser = JSON.parse(usertoken)
      if(authUser){
        console.log("here")
        next();
      }else{
        next({name: 'login'});
      }
    }
    next();
    });

export default router;